import * as React from 'react'

import { pipe } from 'fp-ts/lib/function'
import { SimpleUnit, useUnits } from '@library/react-toolkit'
import { Select } from 'antd'
import { record, array, ord, string, option } from 'fp-ts'

type Props = {
  onChange?: (value: string) => void
  value?: string
  defaultValue?: string
  placeholder?: React.ReactNode
  filter?: (unitID: string, unit: SimpleUnit) => boolean
}

const ordBySnd: ord.Ord<[unknown, string]> = pipe(
  string.Ord,
  ord.contramap(v => v[1])
)

const symbol = (u: SimpleUnit) =>
  pipe(
    u.format,
    array.filterMap(fmt => pipe(fmt.split(' '), array.lookup(1))),
    array.head,
    option.getOrElse(() => '')
  )

const UnitSelect = ({ filter, ...rest }: Props) => {
  const units = useUnits()

  return (
    <Select {...rest}>
      {pipe(
        units,
        !!filter ? record.filterWithIndex(filter) : x => x,
        record.map(u => `${u.name} ${symbol(u)}`),
        record.toArray,
        array.sort(ordBySnd),
        array.map(v => (
          <Select.Option value={v[0]} key={v[0]}>
            {v[1]}
          </Select.Option>
        ))
      )}
    </Select>
  )
}

export default UnitSelect
